export const Channel = typeof BroadcastChannel !== 'undefined' ? new BroadcastChannel('utm-params') : null;

let channelUnusable = false;

export const sendMessage = (message: any) => {
    const channel = Channel;
    if (!channel || channelUnusable) return;

    try {
        channel.postMessage(message);
    } catch {
        channelUnusable = true;
    }
};

export const listenForMessages = (callback: (message: any) => void) => {
    const channel = Channel;
    if (!channel) return;

    channel.onmessage = event => {
        callback(event.data);
        channel.onmessage = null;
    };
};